import backendURLs from '~/misc/backendURLs';

export default (axios, productId) => {
  return axios
    .get(`${backendURLs.products}/${productId}`)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
};
